//register global actions
import "data/redux-form-globals";
import { GlobalActions } from "redux-subspace";

import { types } from "data/user";

GlobalActions.register(types.RESET_CURRENT_USER);
